// services/dictionaryApi.js

import axios from "axios";
import { makeRequest } from "../utils/handleJWT";

// آدرس‌های API برای هر زبان
const DICT_API_URLS = {
  en: "https://umlang.com/dict-en/api/v1/dictionary/translateWord",
  de: "https://umlang.com/dict-de/api/v1/dictionary/translateWord",
  fr: "https://umlang.com/dict-fr/api/v1/dictionary/translateWord",
  it: "https://umlang.com/dict-it/api/v1/dictionary/translateWord",
  tr: "https://umlang.com/dict-tr/api/v1/dictionary/translateWord",
};

/**
 * دریافت ترجمه از API دیکشنری
 * این API نیاز به توکن دارد
 */
export const translateWord = async (fromLang, toLang, word) => {
  const url = DICT_API_URLS[fromLang];

  if (!url) {
    throw new Error(`زبان ${fromLang} پشتیبانی نمی‌شود`);
  }

  return makeRequest(async () => {
    const token = localStorage.getItem("token");

    const response = await axios.post(
      url,
      {
        fromLang,
        toLang,
        word: word.trim(),
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return response.data;
  });
};

/**
 * تشخیص اینکه آیا خطای 402 (نیاز به اشتراک) دریافت شده
 */
export const isQuotaExceededError = (error) => {
  return error?.response?.status === 402;
};
